import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Divider = ({ text = "OR", className }) => {
    return (_jsxs("div", { className: className, style: {
            display: "flex",
            alignItems: "center",
            margin: "24px 0",
        }, children: [_jsx("div", { style: {
                    flex: 1,
                    height: "1px",
                    backgroundColor: "#d1d5db",
                } }), _jsx("span", { style: {
                    padding: "0 16px",
                    color: "#6b7280",
                    fontSize: "14px",
                    fontWeight: 500,
                }, children: text }), _jsx("div", { style: {
                    flex: 1,
                    height: "1px",
                    backgroundColor: "#d1d5db",
                } })] }));
};
